 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		7: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + ({}[chunkId]||chunkId) + ".bundle.js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
 	(function() { /* Start undefined extensions */
 			function mix(dest, src) { // eslint-disable-line no-unused-vars
 				for(var n in src) dest[n] = src[n];
 				return src;
 			}

 			function toUrl(name, referenceModule) {
 				return loaderScope.require.toUrl(name, referenceModule);
 			}

 			function toAbsMid(name, referenceModule) {
 				return loaderScope.require.toAbsMid(name, referenceModule);
 			}

 			// dojo require function.
 			function req(config, dependencies, callback) {
 				return contextRequire(config, dependencies, callback, 0, req);
 			};

 			function createContextRequire(moduleId) { // eslint-disable-line no-unused-vars
 				if (req.absMidsById[moduleId]) {
 					moduleId = req.absMidsById[moduleId];
 				}
 				if (!moduleId) return req;
 				var result = function(a1, a2, a3) {
 					return contextRequire(a1, a2, a3, moduleId, req);
 				};
 				for (var p in req) {
 					if (req.hasOwnProperty(p)) {
 						result[p] = req[p];
 					}
 				}
 				result.toUrl = function(name) {
 					return toUrl(name, moduleId ? {mid: moduleId} : null);
 				};
 				result.toAbsMid = function(name) {
 					return toAbsMid(name, moduleId ? {mid: moduleId} : null);
 				};

 				if (req.undef) {
 					result.undef = function(mid) {
 						req.undef(mid, moduleId);
 					};
 				}
 				return result;
 			}

 			function registerAbsMids(absMids) { // eslint-disable-line no-unused-vars
 				for (var s in absMids) {
 					req.absMids[s] = absMids[s];
 					req.absMidsById[absMids[s]] = s;
 				}
 			}

 			function resolveTernaryHasExpression(expr) { // eslint-disable-line no-unused-vars
 				// Expects an expression of the form supported by dojo/has.js loader, except that module identifiers are
 				// integers corresponding to webpack module ids.  Returns a module reference if evaluation of the expression
 				// using the currently defined features returns a module id, or else undefined.

 				var has = req("dojo/has");
 				var id = has.normalize(expr, function(arg){return arg;});
 				return id && __webpack_require__(id) || undefined;
 			}

 			function findModule(mid, referenceModule, noInstall, asModuleObj) {
 				mid = mid.split("!").map(function(segment) {
 					var isRelative = segment.charAt(0) === '.';
 					if(isRelative && !referenceModule){
 						return mid;
 					}
 					return toAbsMid(segment, referenceModule ? {mid: referenceModule} : null);
 				}).join("!");
 				var result;
 				if (mid in req.absMids && __webpack_require__.m[req.absMids[mid]]) {
 					if (noInstall) {
 						var module = installedModules[req.absMids[mid]];
 						result = module && module.l && (asModuleObj ? module : module.exports);
 					} else {
 						result = __webpack_require__(req.absMids[mid]);
 					}
 				}
 				if (!result) {
 					throw new Error('Module not found: ' + mid);
 				}
 				return result;
 			}

 			function dojoModuleFromWebpackModule(webpackModule) { // eslint-disable-line no-unused-vars
 				var result = {exports: webpackModule.exports};
 				var id = webpackModule.i;
 				if (req.absMidsById[id]) {
 					id = req.absMidsById[id];
 				}
 				result.i = result.id = id;
 				return result;
 			}

 			function contextRequire(a1, a2, a3, referenceModule, req) { // eslint-disable-line no-shadow
 				var type = ({}.toString).call(a1);
 				if (type === '[object String]') {
 					// a3 is passed by require calls injected into dependency arrays for dependencies specified
 					// as identifiers (vs. string literals).
 					var noInstall = !(a3 === false);
 					return findModule(a1, referenceModule, noInstall);
 				} else if (type === '[object Object]') {
 					throw new Error('Require config is not supported by WebPack');
 				}
 				if (type === '[object Array]') {
 					var modules = [], callback = a2, errors = [];
 					a1.forEach(function (mid) {
 						try {
 							modules.push(findModule(mid, referenceModule));
 						} catch (e) {
 							errors.push({mid: mid, error: e});
 						}
 					});
 					if (callback && errors.length === 0) {
 						callback.apply(this, modules);
 					} else {
 						var error = new Error("findModules");
 						error.src = "dojo-webpack-plugin";
 						error.info = errors;
 						req.signal("error", error);
 					}
 					return req;
 				} else {
 					throw new Error('Unsupported require call');
 				}
 			}
 			req.toUrl = toUrl;
 			req.toAbsMid = toAbsMid;
 			req.absMids = {};
 			req.absMidsById = [];
 			req.async = 1;
 		var globalObj = this||window;
 		registerAbsMids({
 			// ./_export = 0
 			// ./_an-object = 1
 			// ./_global = 2
 			// ./_fails = 3
 			// ./_is-object = 4
 			// ./_wks = 5
 			// ./_descriptors = 6
 			// ./_object-dp = 7
 			// ./_to-length = 8
 			// ./_to-object = 9
 			// ./_a-function = 10
 			// ./_hide = 11
 			// ./_redefine = 12
 			// ./_string-html = 13
 			// ./_has = 14
 			// ./_to-iobject = 15
 			// ./_object-gopd = 16
 			// ./_object-gpo = 17
 			// ../../modules/_core = 18
 			// ./_ctx = 19
 			// ./_cof = 20
 			// ./_strict-method = 21
 			// ./_to-primitive = 22
 			// ./_defined = 23
 			// ./_to-integer = 24
 			// ./_object-sap = 25
 			// ./_array-methods = 26
 			// ./_typed-array = 27
 			// ./_metadata = 28
 			// ./_meta = 30
 			// ./_library = 31
 			// ./_add-to-unscopables = 32
 			// ./_property-desc = 33
 			// ./_uid = 34
 			// ./_object-keys = 35
 			// ./_to-absolute-index = 36
 			// ./_object-create = 37
 			// ./_object-gopn = 38
 			// ./_set-species = 39
 			// ./_an-instance = 40
 			// ./_for-of = 41
 			// ./_redefine-all = 42
 			// ./_set-to-string-tag = 43
 			// ./_string-trim = 44
 			// ./_iterators = 45
 			// ./_validate-collection = 46
 			// ./_iobject = 48
 			// ./_object-pie = 49
 			// ./_classof = 50
 			// ./_shared = 52
 			// ./_array-includes = 53
 			// ./_object-gops = 54
 			// ./_is-array = 55
 			// ./_is-regexp = 56
 			// ./_iter-detect = 57
 			// ./_flags = 58
 			// ./_fix-re-wks = 59
 			// ./_species-constructor = 60
 			// ./_user-agent = 61
 			// ./_collection = 62
 			// ./_typed = 63
 			// ./_object-forced-pam = 64
 			// ./_set-collection-of = 65
 			// ./_set-collection-from = 66
 			// ./_dom-create = 67
 			// ./_wks-define = 68
 			// ./_shared-key = 69
 			// ./_enum-bug-keys = 70
 			// ./_html = 71
 			// ./_set-proto = 72
 			// ./_string-ws = 73
 			// ./_inherit-if-required = 74
 			// ./_string-repeat = 75
 			// ./_math-sign = 76
 			// ./_math-expm1 = 77
 			// ./_string-at = 78
 			// ./_iter-define = 79
 			// ./_iter-create = 80
 			// ./_string-context = 81
 			// ./_fails-is-regexp = 82
 			// ./_is-array-iter = 83
 			// ./_create-property = 84
 			// ./core.get-iterator-method = 85
 			// ./_array-species-create = 86
 			// ./_array-fill = 87
 			// ./es6.array.iterator = 88
 			// ./_task = 89
 			// ./_microtask = 90
 			// ./_new-promise-capability = 91
 			// ./_typed-buffer = 92
 			// ./../../webpack/buildin/global.js = 93
 			// ./_ie8-dom-define = 94
 			// ./_wks-ext = 95
 			// ./_object-keys-internal = 96
 			// ./_object-dps = 97
 			// ./_object-gopn-ext = 98
 			// ./_object-assign = 99
 			// ./_bind = 100
 			// ./_invoke = 101
 			// ./_parse-int = 102
 			// ./_parse-float = 103
 			// ./_a-number-value = 104
 			// ./_is-integer = 105
 			// ./_math-log1p = 106
 			// ./_math-fround = 107
 			// ./_iter-call = 108
 			// ./_array-reduce = 109
 			// ./_array-copy-within = 110
 			// ./_iter-step = 111
 			// ./modules/es6.regexp.flags = 112
 			// ./_perform = 113
 			// ./_promise-resolve = 114
 			// ./es6.map = 115
 			// ./_collection-strong = 116
 			// ./es6.set = 117
 			// ./es6.weak-map = 118
 			// ./_collection-weak = 119
 			// ./_to-index = 120
 			// ./_own-keys = 121
 			// ./_flatten-into-array = 122
 			// ./_string-pad = 123
 			// ./_object-to-array = 124
 			// ./_collection-to-json = 125
 			// ./_array-from-iterable = 126
 			// ./_math-scale = 127
 			// babel-polyfill = 130
 			// core-js/shim = 131
 			// ./modules/es6.symbol = 132
 			// ./_enum-keys = 133
 			// ./modules/es6.object.create = 134
 			// ./modules/es6.object.define-property = 135
 			// ./modules/es6.object.define-properties = 136
 			// ./modules/es6.object.get-own-property-descriptor = 137
 			// ./modules/es6.object.get-prototype-of = 138
 			// ./modules/es6.object.keys = 139
 			// ./modules/es6.object.get-own-property-names = 140
 			// ./modules/es6.object.freeze = 141
 			// ./modules/es6.object.seal = 142
 			// ./modules/es6.object.prevent-extensions = 143
 			// ./modules/es6.object.is-frozen = 144
 			// ./modules/es6.object.is-sealed = 145
 			// ./modules/es6.object.is-extensible = 146
 			// ./modules/es6.object.assign = 147
 			// ./modules/es6.object.is = 148
 			// ./_same-value = 149
 			// ./modules/es6.object.set-prototype-of = 150
 			// ./modules/es6.object.to-string = 151
 			// ./modules/es6.function.bind = 152
 			// ./modules/es6.function.name = 153
 			// ./modules/es6.function.has-instance = 154
 			// ./modules/es6.parse-int = 155
 			// ./modules/es6.parse-float = 156
 			// ./modules/es6.number.constructor = 157
 			// ./modules/es6.number.to-fixed = 158
 			// ./modules/es6.number.to-precision = 159
 			// ./modules/es6.number.epsilon = 160
 			// ./modules/es6.number.is-finite = 161
 			// ./modules/es6.number.is-integer = 162
 			// ./modules/es6.number.is-nan = 163
 			// ./modules/es6.number.is-safe-integer = 164
 			// ./modules/es6.number.max-safe-integer = 165
 			// ./modules/es6.number.min-safe-integer = 166
 			// ./modules/es6.number.parse-float = 167
 			// ./modules/es6.number.parse-int = 168
 			// ./modules/es6.math.acosh = 169
 			// ./modules/es6.math.asinh = 170
 			// ./modules/es6.math.atanh = 171
 			// ./modules/es6.math.cbrt = 172
 			// ./modules/es6.math.clz32 = 173
 			// ./modules/es6.math.cosh = 174
 			// ./modules/es6.math.expm1 = 175
 			// ./modules/es6.math.fround = 176
 			// ./modules/es6.math.hypot = 177
 			// ./modules/es6.math.imul = 178
 			// ./modules/es6.math.log10 = 179
 			// ./modules/es6.math.log1p = 180
 			// ./modules/es6.math.log2 = 181
 			// ./modules/es6.math.sign = 182
 			// ./modules/es6.math.sinh = 183
 			// ./modules/es6.math.tanh = 184
 			// ./modules/es6.math.trunc = 185
 			// ./modules/es6.string.from-code-point = 186
 			// ./modules/es6.string.raw = 187
 			// ./modules/es6.string.trim = 188
 			// ./modules/es6.string.iterator = 189
 			// ./modules/es6.string.code-point-at = 190
 			// ./modules/es6.string.ends-with = 191
 			// ./modules/es6.string.includes = 192
 			// ./modules/es6.string.repeat = 193
 			// ./modules/es6.string.starts-with = 194
 			// ./modules/es6.string.anchor = 195
 			// ./modules/es6.string.big = 196
 			// ./modules/es6.string.blink = 197
 			// ./modules/es6.string.bold = 198
 			// ./modules/es6.string.fixed = 199
 			// ./modules/es6.string.fontcolor = 200
 			// ./modules/es6.string.fontsize = 201
 			// ./modules/es6.string.italics = 202
 			// ./modules/es6.string.link = 203
 			// ./modules/es6.string.small = 204
 			// ./modules/es6.string.strike = 205
 			// ./modules/es6.string.sub = 206
 			// ./modules/es6.string.sup = 207
 			// ./modules/es6.date.now = 208
 			// ./modules/es6.date.to-json = 209
 			// ./modules/es6.date.to-iso-string = 210
 			// ./_date-to-iso-string = 211
 			// ./modules/es6.date.to-string = 212
 			// ./modules/es6.date.to-primitive = 213
 			// ./_date-to-primitive = 214
 			// ./modules/es6.array.is-array = 215
 			// ./modules/es6.array.from = 216
 			// ./modules/es6.array.of = 217
 			// ./modules/es6.array.join = 218
 			// ./modules/es6.array.slice = 219
 			// ./modules/es6.array.sort = 220
 			// ./modules/es6.array.for-each = 221
 			// ./_array-species-constructor = 222
 			// ./modules/es6.array.map = 223
 			// ./modules/es6.array.filter = 224
 			// ./modules/es6.array.some = 225
 			// ./modules/es6.array.every = 226
 			// ./modules/es6.array.reduce = 227
 			// ./modules/es6.array.reduce-right = 228
 			// ./modules/es6.array.index-of = 229
 			// ./modules/es6.array.last-index-of = 230
 			// ./modules/es6.array.copy-within = 231
 			// ./modules/es6.array.fill = 232
 			// ./modules/es6.array.find = 233
 			// ./modules/es6.array.find-index = 234
 			// ./modules/es6.array.species = 235
 			// ./modules/es6.regexp.constructor = 236
 			// ./modules/es6.regexp.to-string = 237
 			// ./modules/es6.regexp.match = 238
 			// ./modules/es6.regexp.replace = 239
 			// ./modules/es6.regexp.search = 240
 			// ./modules/es6.regexp.split = 241
 			// ./modules/es6.promise = 242
 			// ./modules/es6.weak-set = 243
 			// ./modules/es6.typed.array-buffer = 244
 			// ./modules/es6.typed.data-view = 245
 			// ./modules/es6.typed.int8-array = 246
 			// ./modules/es6.typed.uint8-array = 247
 			// ./modules/es6.typed.uint8-clamped-array = 248
 			// ./modules/es6.typed.int16-array = 249
 			// ./modules/es6.typed.uint16-array = 250
 			// ./modules/es6.typed.int32-array = 251
 			// ./modules/es6.typed.uint32-array = 252
 			// ./modules/es6.typed.float32-array = 253
 			// ./modules/es6.typed.float64-array = 254
 			// ./modules/es6.reflect.apply = 255
 			// ./modules/es6.reflect.construct = 256
 			// ./modules/es6.reflect.define-property = 257
 			// ./modules/es6.reflect.delete-property = 258
 			// ./modules/es6.reflect.enumerate = 259
 			// ./modules/es6.reflect.get = 260
 			// ./modules/es6.reflect.get-own-property-descriptor = 261
 			// ./modules/es6.reflect.get-prototype-of = 262
 			// ./modules/es6.reflect.has = 263
 			// ./modules/es6.reflect.is-extensible = 264
 			// ./modules/es6.reflect.own-keys = 265
 			// ./modules/es6.reflect.prevent-extensions = 266
 			// ./modules/es6.reflect.set = 267
 			// ./modules/es6.reflect.set-prototype-of = 268
 			// ./modules/es7.array.includes = 269
 			// ./modules/es7.array.flat-map = 270
 			// ./modules/es7.array.flatten = 271
 			// ./modules/es7.string.at = 272
 			// ./modules/es7.string.pad-start = 273
 			// ./modules/es7.string.pad-end = 274
 			// ./modules/es7.string.trim-left = 275
 			// ./modules/es7.string.trim-right = 276
 			// ./modules/es7.string.match-all = 277
 			// ./modules/es7.symbol.async-iterator = 278
 			// ./modules/es7.symbol.observable = 279
 			// ./modules/es7.object.get-own-property-descriptors = 280
 			// ./modules/es7.object.values = 281
 			// ./modules/es7.object.entries = 282
 			// ./modules/es7.object.define-getter = 283
 			// ./modules/es7.object.define-setter = 284
 			// ./modules/es7.object.lookup-getter = 285
 			// ./modules/es7.object.lookup-setter = 286
 			// ./modules/es7.map.to-json = 287
 			// ./modules/es7.set.to-json = 288
 			// ./modules/es7.map.of = 289
 			// ./modules/es7.set.of = 290
 			// ./modules/es7.weak-map.of = 291
 			// ./modules/es7.weak-set.of = 292
 			// ./modules/es7.map.from = 293
 			// ./modules/es7.set.from = 294
 			// ./modules/es7.weak-map.from = 295
 			// ./modules/es7.weak-set.from = 296
 			// ./modules/es7.global = 297
 			// ./modules/es7.system.global = 298
 			// ./modules/es7.error.is-error = 299
 			// ./modules/es7.math.clamp = 300
 			// ./modules/es7.math.deg-per-rad = 301
 			// ./modules/es7.math.degrees = 302
 			// ./modules/es7.math.fscale = 303
 			// ./modules/es7.math.iaddh = 304
 			// ./modules/es7.math.isubh = 305
 			// ./modules/es7.math.imulh = 306
 			// ./modules/es7.math.rad-per-deg = 307
 			// ./modules/es7.math.radians = 308
 			// ./modules/es7.math.scale = 309
 			// ./modules/es7.math.umulh = 310
 			// ./modules/es7.math.signbit = 311
 			// ./modules/es7.promise.finally = 312
 			// ./modules/es7.promise.try = 313
 			// ./modules/es7.reflect.define-metadata = 314
 			// ./modules/es7.reflect.delete-metadata = 315
 			// ./modules/es7.reflect.get-metadata = 316
 			// ./modules/es7.reflect.get-metadata-keys = 317
 			// ./modules/es7.reflect.get-own-metadata = 318
 			// ./modules/es7.reflect.get-own-metadata-keys = 319
 			// ./modules/es7.reflect.has-metadata = 320
 			// ./modules/es7.reflect.has-own-metadata = 321
 			// ./modules/es7.reflect.metadata = 322
 			// ./modules/es7.asap = 323
 			// ./modules/es7.observable = 324
 			// ./modules/web.timers = 325
 			// ./modules/web.immediate = 326
 			// ./modules/web.dom.iterable = 327
 			// regenerator-runtime/runtime = 328
 			// core-js/fn/regexp/escape = 329
 			// ../../modules/core.regexp.escape = 330
 			// ./_replacer = 331
 			// /var/www/html/Moringa_genome/build/dojo-webpack-plugin-loader/dojo/dojo.js = 332
 			'src/JBrowse/main':369
 		});

 		globalObj.require = req;
 			(this||window)["webpackJsonp"].registerAbsMids = registerAbsMids;

 		// expose the Dojo compatibility functions as a properties of __webpack_require__
 		if (__webpack_require__.dj) throw new Error("__webpack_require__.dj name collision.")
 		__webpack_require__.dj = {
 			r: req,
 			c: createContextRequire,
 			m: dojoModuleFromWebpackModule,
 			h: resolveTernaryHasExpression
 		};
 		var loaderScope = {document:globalObj.document};
 		loaderScope.global = loaderScope.window = loaderScope;
 		globalObj.dojoConfig = globalObj.dojoConfig || {}
 		var userConfig = mix(globalObj.dojoConfig, ({'baseUrl':'.','packages':[({'name':'dojo','location':'./dist/dojo'}),({'name':'dijit','location':'./dist/dijit'}),({'name':'dojox','location':'./dist/dojox'}),({'name':'JBrowse','location':'src/JBrowse','lib':'.'}),({'name':'dgrid','location':'./dist/dgrid','lib':'.'}),({'name':'dstore','location':'./dist/dojo-dstore','lib':'.'}),({'name':'jszlib','location':'./dist/jszlib','lib':'.'}),({'name':'FileSaver','location':'./dist/filesaver.js','lib':'.'}),({'name':'CategoryUrl','css':'css','js':'js','location':'plugins/CategoryUrl/js','pluginDir':'plugins/CategoryUrl'}),({'name':'DebugEvents','css':'css','js':'js','location':'plugins/DebugEvents/js','pluginDir':'plugins/DebugEvents'}),({'name':'FeatureSequence','css':'css','js':'js','location':'plugins/FeatureSequence/js','pluginDir':'plugins/FeatureSequence'}),({'name':'HideTrackLabels','css':'css','js':'js','location':'plugins/HideTrackLabels/js','pluginDir':'plugins/HideTrackLabels'}),({'name':'NeatCanvasFeatures','css':'css','js':'js','location':'plugins/NeatCanvasFeatures/js','pluginDir':'plugins/NeatCanvasFeatures'}),({'name':'NeatHTMLFeatures','css':'css','js':'js','location':'plugins/NeatHTMLFeatures/js','pluginDir':'plugins/NeatHTMLFeatures'}),({'name':'RegexSequenceSearch','css':'css','js':'js','location':'plugins/RegexSequenceSearch/js','pluginDir':'plugins/RegexSequenceSearch'})],'async':true}));
 		var defaultConfig = ({'hasCache':({'webpack':1,'host-browser':1,'dom':1,'dojo-loader':1,'dojo-has-api':1,'dojo-dom-ready-api':1,'dojo-sniff':1,'dojo-test-sniff':1,'config-deferredInstrumentation':1,'config-tlmSiblingOfDojo':1})});
 		var dojoLoader = __webpack_require__(332);
 		dojoLoader.call(loaderScope, userConfig, defaultConfig, loaderScope, loaderScope);
 		['baseUrl','has','rawConfig','on','signal'].forEach(function(name) {req[name] = loaderScope.require[name]})
 	})(); /* End undefined extensions */
 	var req=	(function() {
 			function warnDeprecated() {
 				console.warn('req is deprecated and will be removed in a future release.');
 			}
 			var req = __webpack_require__.dj.r;
 			function depReq() {
 				warnDeprecated();
 				return req.apply(this, arguments);
 			};
 			Object.keys(req).forEach(function(name) {
 				Object.defineProperty(depReq, name, {
 					get: function() {
 						warnDeprecated();
 						return req[name];
 					},
 					enumerable: true,
 					configurable: false
 				});
 			});
 			return depReq;
 		})();


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 369);



// WEBPACK FOOTER //
// webpack/bootstrap 30dd971a39ebf04ae535